import { LINK_MOVE_TYPE } from 'core/constants'
import { BRIDGE } from 'core/constants/bridge'
import { getPartnerId, getUA } from 'core/singleton'
import { STORE_MARKETING_GTM } from 'core/store/analysis'
import { IS_OPEN_LINK, STORE_ROOT_PROPS } from 'core/store/global'
import { requestBridge } from 'core/util/default'
import { getExecutorForPartner } from 'core/util/partner'
import { moveToLink } from 'core/util/url'
import { useCallback } from 'react'
import { useRecoilValue } from 'recoil'

/**
 * 라이브 편성표의 상품 정보를 정제하는 hook
 * @param productListDetail 상품 정보 배열
 */
export default function useProductInfo({
  broadcastUrl,
  productListDetail,
}: {
  broadcastUrl: string
  productListDetail: ProductListDetail[]
}) {
  const marketingGTM = useRecoilValue(STORE_MARKETING_GTM)
  const root = useRecoilValue(STORE_ROOT_PROPS)
  const isOpenLink = useRecoilValue(IS_OPEN_LINK)
  const partnerId = getPartnerId()
  const { isSDK } = getUA()

  const {
    productName,
    brandName,
    discountRate,
    sellingPrice,
    price,
    currencyNotation,
    priceTypeCode,
    discountTypeCode,
    realTimeProductShow = true,
    redirectUrl,
    productId,
  } = productListDetail[0] || {}
  const productThumbnailUrl = productListDetail[0]?.productThumbnailUrlList[0].thumbnailUrl

  const getPriceText = useCallback(
    (_price: number | undefined) => {
      const options = { maximumFractionDigits: 2 }
      const price = Number(_price).toLocaleString('ko-KR', options) ?? 0

      if (!currencyNotation || currencyNotation === '₩') {
        return `${price}원`
      }

      return `${currencyNotation + price}`
    },
    [currencyNotation],
  )

  const handleClickProduct = () => {
    let productUrl = redirectUrl
    if (marketingGTM?.checkAvailability()) {
      let queryStringPrefix = productUrl.indexOf('?') >= 0 ? '&' : '?'
      productUrl = productUrl.concat(`${queryStringPrefix}_gl=${marketingGTM.getGl()}`)

      queryStringPrefix = broadcastUrl.indexOf('?') >= 0 ? '&' : '?'
      broadcastUrl = broadcastUrl.concat(`${queryStringPrefix}_gl=${marketingGTM.getGl()}`)
    }

    productUrl =
      getExecutorForPartner(partnerId)?.appendSearchParamsToProductUrl?.(new URL(productUrl))
        .href ?? productUrl

    if (root?.bridge || window[BRIDGE.PRODUCT] || isSDK) {
      requestBridge(BRIDGE.PRODUCT, {
        productId,
        productUrl,
        broadcastUrl,
      })
      return
    }

    moveToLink({
      link: productUrl,
      type: isOpenLink ? LINK_MOVE_TYPE.REPLACE : LINK_MOVE_TYPE.REDIRECT,
    })
  }

  if (!realTimeProductShow) return {}
  return {
    productThumbnailUrl,
    productName,
    brandName,
    discountRate,
    sellingPrice: getPriceText(sellingPrice),
    price: getPriceText(price),
    priceTypeCode,
    discountTypeCode,
    handleClickProduct,
  }
}
